import React, { Fragment, useEffect, useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import {
  Box,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  useMediaQuery,
} from '@material-ui/core'

import useStyles from './styles'
import theme from 'theme'

const FontCustomization = () => {
  const classes = useStyles()
  const { control, watch, setValue } = useFormContext()
  const fontFamily = watch('fontFamily')

  const [fontType, setFontType] = useState('default')

  useEffect(() => {
    if (fontFamily) {
      setFontType('custom')
    }
  }, [fontFamily])

  const handleRadioChange = (e) => {
    const value = e.target.value
    setFontType(value)
    if (value === 'default') {
      setValue('fontFamily', '')
    }
  }

  const mdUp = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  })

  return (
    <Fragment>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="flex-start"
        alignItems="flex-start"
        width="100%"
      >
        <FormControl component="fieldset">
          <FormLabel component="legend" className={classes.formLabel}>
            Defina a fonte que será utilizada em seu banner de cookies:
          </FormLabel>
          <RadioGroup
            aria-label="font-type"
            name="font-type"
            value={fontType}
            onChange={handleRadioChange}
          >
            <FormControlLabel
              value="default"
              control={<Radio color="primary" />}
              label="Arial (padrão)"
            />
            <FormControlLabel
              value="custom"
              control={<Radio color="primary" />}
              label="Personalizado"
            />
          </RadioGroup>
        </FormControl>

        <Box
          mt={2}
          width="100%"
          display={fontType === 'custom' ? 'block' : 'none'}
        >
          <Controller
            as={TextField}
            name="fontFamily"
            control={control}
            label="Nome da Fonte (font-family)"
            variant="outlined"
            fullWidth
            placeholder="Ex: 'Roboto', sans-serif"
            InputLabelProps={{ shrink: true }}
          />
        </Box>

        <Box
          p={2}
          mt={2}
          bgcolor={theme.palette.custom.light}
          borderRadius={1}
          display="flex"
          flexDirection="column"
          gridGap={theme.spacing(1.5)}
        >
          <Typography color="primary" variant="h6">
            Informação
          </Typography>
          <Typography align="justify" variant="body2">
            Insira o nome da fonte (font-family) exatamente como utilizada em
            seu site. Você poderá informar uma ou mais fontes, desde que
            separadas por vírgula. O banner não instala novas fontes, apenas
            utiliza as já disponíveis. Caso a fonte não seja encontrada, será
            aplicada a fonte Arial.
          </Typography>
        </Box>
      </Box>
      {mdUp && <Divider orientation="vertical" variant="middle" />}
    </Fragment>
  )
}

export default FontCustomization
